import { AppRouteProps } from '@harea/component'
import React from 'react'

const History = React.lazy(() => import('./container/HistoryContainer'))

export const HistoryRoutes: Array<AppRouteProps> = [
    { 
        path: 'history', 
        element: <History />,
    }
]
